module.exports = __webpack_public_path__ + "img/1679986738278-Screenshot_2023-03-28-13-47-11-48_1c337646f29875672b5a61192b9010f9.jpg.401b0b13.webp";